import { render, staticRenderFns } from "./CalcCard.vue?vue&type=template&id=18de0767&scoped=true"
import script from "./CalcCard.vue?vue&type=script&lang=js"
export * from "./CalcCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de0767",
  null
  
)

export default component.exports